export const isServer = typeof window === 'undefined';
export const isProduction =
  process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isPreview = process.env.VERCEL_ENV === 'preview' || process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview';
export const isCI = !!process.env.CI;
